import { gateway } from './env'
import * as util from '../utils/util'
import axios from 'axios'
import { Message } from 'element-ui';
import router from "../router/index"

import { catchError } from '../utils/util';


//网络请求配置.
export const qunInstance = axios.create({
  baseURL: gateway,          //gateway
  timeout: 100000
})

// 请求拦截器
qunInstance.interceptors.request.use(
  config => {
    if (config.customBaseURL != undefined) config.baseURL = config.customBaseURL;
    const token = sessionStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
  }
)
// 响应拦截器
qunInstance.interceptors.response.use(
  res => {
    if (res.data.code == 1500) {
      Message.error(res.data.message)
      router.push("/login")
      return
    }
    return Promise.resolve(res)
  },
  error => {
    const { response } = error
    catchError(response)
  }
)


export async function initUrl(url = '', data = {}, type = 'POST', specialConfig = {}) {
  type = type.toUpperCase()
  if (type === 'GET') {
    try {
      let res = await qunInstance({
        method: 'GET',
        url,
        params: data,
        responseType: specialConfig.responseType,
        customBaseURL: specialConfig.customBaseURL,
      })
      return new Promise((resolve) => {
        if (res.status == 200) {
          if (res.data.code == 1500) {
            res.status = res.data.code
            util.catchError(res)
          } else {
            resolve(res)
          }
        } else {
          res.status = res.data.code
          util.catchError(res)
        }
      })
    } catch (err) {

    }
  } else {
    try {
      let res = await qunInstance({
        method: 'POST',
        url,
        params: specialConfig.parameterType == 'QSP' ? data : undefined,
        data: specialConfig.parameterType == 'QSP' ? undefined : data
      })
      return new Promise((resolve) => {
        if (res.status == 200) {
          if (res.code == 1500) {
            res.status = res.code
            util.catchError(res)
          } else {
            resolve(res)
          }
        } else {
          res.status = res.data.code
          util.catchError(res)
        }
      })
    } catch (err) {
      util.catchError(err)
    }
  }
}



// WEBPACK FOOTER //
// ./src/config/axios_config.js